exports.XMLHttpRequest = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-video/src/xmlhttprequest.js
// module id = 999
// module chunks = 0